export const isProduction = process.env.REACT_APP_ENVIRONMENT === 'production'

// REACT_APP_3D_API_URL: trỏ FE vào 3d-api chạy local (vd http://localhost:3721). Không đặt → dùng URL staging/production như cũ.
const API_URL = process.env.REACT_APP_3D_API_URL || (process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://3d.merchize.com' : 'https://tool3d-staging.merchize.com')
const FACTORY_API_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://factory.merchize.com' : 'https://f1-staging.merchize.com'

const config = {
    development: {
        url: API_URL,
        factory_url: FACTORY_API_URL,
    },
    production: {
        url: API_URL,
        factory_url: FACTORY_API_URL,
    },
    test: {
        url: API_URL,
        factory_url: FACTORY_API_URL,
    }
}

const nodeEnv = process.env.NODE_ENV || 'development'

export default config[nodeEnv]
